import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'
import { getConvexToken } from '../../convex'

export default function useFilterNotifications(externalFilterId) {
	const token = getConvexToken()

	// Get the Convex filter for this tab
	const filters = useQuery(
		api.filters.getFiltersByUser,
		token ? { token } : 'skip',
	)

	const convexFilter = filters?.find(
		f => f.filterId === externalFilterId
	) || null

	// Subscribe to user's notifications in real-time
	// This gives us instant push updates via WebSocket when new loads match
	const allNotifications = useQuery(
		api.notifications.getNotificationsForUser,
		token && convexFilter ? { token, limit: 100 } : 'skip',
	)

	if (!convexFilter || !allNotifications) {
		return {
			notifications: [],
			convexFilterId: null,
			loading: !filters || (convexFilter && !allNotifications),
		}
	}

	// Filter notifications for THIS specific filter only (UNREAD only)
	const filterNotifications = allNotifications.filter(
		n => n.filter?._id === convexFilter._id && !n.read
	)

	return {
		notifications: filterNotifications,
		convexFilterId: convexFilter._id,
		loading: false,
	}
}
